import { render } from "./LatestIdea.vue?vue&type=template&id=0de041d2&scoped=true"
import script from "./LatestIdea.vue?vue&type=script&lang=js"
export * from "./LatestIdea.vue?vue&type=script&lang=js"

import "./LatestIdea.vue?vue&type=style&index=0&id=0de041d2&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de041d2"]])

export default __exports__